import React from 'react';
import './Consultatii.css';

export default function Consultatii() {
    const openAppointmentForm = () => {
        window.open("/formular-programare", "");
    };

    const requestConsultation = () => {
        window.location.href = "mailto:optizak@gmail.com?subject=Solicitare Consultație Oftalmologică";
    };

    const downloadInfo = () => {
        const url = "https://example.com/info-consultatii.pdf";
        window.open(url, "_blank");
    };

    return (
        <div className="consultatii-page">
            <div className="hero-section">
                <img src="./Imagini/consultatii.jpg" className="hero-image" alt="Consultații oftalmologice" />
                <div className="overlay">
                    <h1 className="hero-title">Consultații Oftalmologice</h1>
                </div>
            </div>

            <div className="content-wrapper">
                <section className="services">
                    <div className="service-cards">
                        {[
                            { title: "Tonometria", description: "Măsurarea tensiunii intraoculare." },
                            { title: "Autorefractometria", description: "Măsurarea subiectivă a dioptriilor." },
                            { title: "Biomicroscopia", description: "Examinarea părții anterioare a globului ocular (cornee, iris, cristalin)." },
                            { title: "Vederea binoculară", description: "Capacitatea de a percepe imaginile recepționate de fiecare ochi în parte, ca o singură imagine." },
                            { title: "Motilitatea oculară", description: "Examinarea pentru cazurile de strabism, diplopie, dureri oculare sau dificultăți în munca de aproape." },
                            { title: "Fundul de ochi", description: "Examinarea nervului optic, vaselor sanguine și retinei." }
                        ].map((service, index) => (
                            <div className="card" key={index}>
                                <div className="card-body">
                                    <h4 className="card-title">{service.title}</h4>
                                    <p className="card-text">{service.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="about-optik">
                    <h2 className="section-title">Despre OptiZak Brașov</h2>
                    <p className="section-description">
                        La OptiZak, Medicul oftalmolog și optometriștii noștri îți oferă consultanță pe parcursul întregului proces incepand de la consultatia propiu-zisa pana la alegerea ramelor și lentilelor aeriene sau de contact
                        asigurându-ne că fiecare produs se potrivește perfect nevoilor tale vizuale și estetice.
                        Te așteptăm să beneficiezi de soluțiile noastre optice de calitate, la prețuri excelente!
                    </p>
                </section>

                <section className="schedule">
                    <h2 className="section-title">Program de consultații oftalmologice</h2>
                    <div className="doctor-schedule">
                        <div className="doctor-name">Optometrist. Camelia Zaharia</div>
                        <ul className="schedule-list">
                            <li>Luni</li>
                            <li>Marți</li>
                            <li>Miercuri</li>
                            <li>Joi</li>
                            <li>Vineri</li>
                        </ul>
                    </div>
                </section>

                <div className="actions text-center">
                    <button onClick={openAppointmentForm} className="btn btn-primary">
                        Deschide Formular de Programare
                    </button>
                    <button onClick={requestConsultation} className="btn btn-success">
                        Solicită Consultație
                    </button>
                    <button onClick={downloadInfo} className="btn btn-info">
                        Descarcă Informații
                    </button>
                </div>
            </div>
        </div>
    );
}
